import Vue from 'vue'
import VueRouter from 'vue-router'
//import RoomsView from '../views/RoomsView.vue'
//import AuthView from "@/views/AuthView";
import store from "../store";
//import UserProfileView from "@/views/UserProfileView";
import layout from "@/layout/layout_main";

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    name:'landing',
    component:layout
  }

]

const router = new VueRouter({
  routes,
  mode:'history'
})
router.beforeEach(async (to, from, next) =>{
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  //rquires auth && no user
  if(requiresAuth && !(await store.dispatch("user/getCurrentUser"))){
    next({name:"/"});
    //no requires auth and user (auth)
  }else if (!requiresAuth && (await store.dispatch("user/getCurrentUser"))){
    next({name:"Home"});
  }else{
    next();
  }
});

export default router
